import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DcBadgeModule } from '@datachain/ui-sdk/components/app-badge';
import { DcPageModule } from '@datachain/ui-sdk/components/app-page';
import { DcPanelModule } from '@datachain/ui-sdk/components/app-panel';
import { DcAvatarModule } from '@datachain/ui-sdk/components/avatar';
import { DcArrayPipeModule } from '@datachain/ui-sdk/pipes';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DxDataGridModule } from 'devextreme-angular';

import { MaterialModule } from '../ui/material.module';
import { UiModule } from '../ui/ui.module';
import { TraceListComponent } from './components/trace-list/trace-list.component';
import {
	TraceEffects,
	TraceFeatureKey,
	traceReducers,
	TraceSelector,
} from './store';
import { TraceAdapter } from './trace.adapter';

@NgModule({
	declarations: [TraceListComponent],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		FormsModule,
		UiModule,
		MaterialModule,
		StoreModule.forFeature(TraceFeatureKey, traceReducers),
		EffectsModule.forFeature([TraceEffects]),
		DxDataGridModule,
		DcPageModule,
		DcPanelModule,
		DcArrayPipeModule,
		DcAvatarModule,
		DcBadgeModule,
	],
	providers: [TraceAdapter, TraceSelector],
})
export class TraceModule {
	public constructor(private readonly injector: Injector) {
		const traceListComponent = createCustomElement(TraceListComponent, {
			injector,
		});
		customElements.define('app-trace-list', traceListComponent);
	}
}
